module.exports = __webpack_public_path__ + "img/seller.a16bbbe5.png";